import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import type { ReactNode } from 'react';

export interface ApplicationProvidersProps {
  readonly children: ReactNode;
  readonly queryClient: QueryClient;
}

export function ApplicationProviders({ children, queryClient }: ApplicationProvidersProps) {
  return (
    <ConfigProvider
      drawer={{ focusable: { focusTriggerAfterClose: true, trap: true } }}
      locale={zhCN}
      modal={{ focusable: { focusTriggerAfterClose: true, trap: true } }}
      theme={{ cssVar: { key: 'badminton' } }}
    >
      <AntdApp>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
